/**
 * naming conventions:
 * use device agnostic verb (e.g. "select" not "click" or "touch")
 * use basic noun, what is it?
 *
 *  verb   noun
 * "select_button"
 */

const AMPLITUDE_EVENTS = {
    CHANGE_FIELD: "change_field",
    DISMISS_MODAL: "dismiss_modal",
    REPORT_DIAGNOSTICS: "report_diagnostics",
    REPORT_PERFORMANCE_TELMETRY: "report_performance_telemetry",
    INITIALIZE_APPLICATION: "initialize_application_complete_event",
    LIAT_APP_START: "cached_liat_load_complete_event",
    LIAT_APP_START_FULL: "full_liat_load_complete_event",
    SELECT_BUTTON: "select_button",
    SELECT_EVENT: "select_event",
    SELECT_FIELD: "select_field",
    SELECT_LINK: "select_link",
    SELECT_MENU: "select_menu",
    SELECT_MODAL: "select_modal",
    SELECT_SLIDER: "select_slider",
    SELECT_TOOLTIP: "select_tooltip",
    SELECT_VIEW: "select_view",
    SELECT_WIDGET: "select_widget",
    SELECT_TITLE: "select_title",
    SELECT_SEARCH: "select_search",
    STARTFLOW_LINK_ACCOUNT: "startflow_link_account",
    ENDFLOW_LINK_ACCOUNT: "endflow_link_account",
    TOGGLE_EVENT: "toggle_event",
    TTLIATF: "time_to_liat_full_load",
    TTLIAT: "time_to_liat_load",
    VIEW_PAGE: "view_page",
    VIEW_WIDGET: "view_widget",
    VIEW_ZS_CARD: "view_zero_state_card",
    SELECT_DASHBOARD_TILE: "select_dashboard_tile",
    DEFAULT_TAB: "default_tab",
    CLOSE_BUTTON: "click_x"
} as const;

export default AMPLITUDE_EVENTS;
